import { useEffect, useRef, useCallback, useContext } from "react";
import { Input, Checkbox, Form, Radio } from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import FormCustomIDField from "../ContentConfig/FormCustomIDField";
import { CKCONFIG, FREE_TEXT_CKCONFIG } from "../config";
import { Context } from "../EditorContext";
import TrimmedInput from "../FormCommonField/FormTrimmedInput";


export const TextContentEditor = ({ value, onChange, config }) => {
  const ref = useRef();
  const editorRef = useRef();
  const { mergeTag } = useContext(Context);

  const handleChange = useCallback(() => {
    editorRef.current.getData();
    onChange();
  }, [editorRef, onChange]);

  useEffect(() => {
    ref.current.setAttribute("contenteditable", "true");
    CKEDITOR.config.allowedContent = true;
    CKEDITOR.disableAutoInline = true;

    const editor = CKEDITOR.replace(ref.current, {
      ...(config || CKCONFIG),
      mergetags: mergeTag,
    });
    editor.setData(value || "");
    editor.on("change", () => {
      if (onChange) {
        onChange(editor.getData());
      }
    });
    editorRef.current = editor;

    return () => {
      editorRef.current.destroy();
    };
  }, [mergeTag]);

  return (
    <div
      style={{
        minHeight: 300,
      }}
    >
      <div className="form-terms-conf" ref={ref} onInput={handleChange}></div>
    </div>
  );
};

export default ({node}) => {
  const defalutLabel = node?.data?.label || ""
  return (
    <>
      <Form.Item label="Label" name="label" rules={[{ required: true, max: 256}]}>
      <TrimmedInput/>
      </Form.Item>
      <FormCustomIDField />
      <Form.Item name="required" valuePropName="checked">
        <Checkbox>Required</Checkbox>
      </Form.Item>
      <Form.Item label="Terms type" name={"termsType"}>
        <Radio.Group buttonStyle="solid">
          <Radio.Button value="free">Free input </Radio.Button>
          <Radio.Button value="popup">Default popup</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const termsType = getFieldValue("termsType");
          if (termsType === "popup") {
            return (
              <>
                <Form.Item label={"Description"} name="desc">
                  <Input />
                </Form.Item>
                <Form.Item label="Popup content" name="content">
                  <TextContentEditor  />
                </Form.Item>
              </>
            );
          } else if (termsType === "free") {
            return (
              <Form.Item label="Terms" name="freeText">
                <TextContentEditor config={FREE_TEXT_CKCONFIG} />
              </Form.Item>
            );
          }
          return null;
        }}
      </Form.Item>
      <ContentPadding />
    </>
  );
};
